import React from 'react';
import { Navigate, Route } from 'react-router';
import { Overview as CompetitionsOverview } from '@pages/Portal/Competitions/Overview';
import { Feed as CompetitionsFeed } from '@pages/Portal/Competitions/Feed';
import { CompetitionDetails } from '@pages/Portal/Competitions/CompetitionDetails';
import { ResultsOverview } from '@pages/Portal/Competitions/Results/Overview';
import { ResultDetails } from '@pages/Portal/Competitions/Results/Details';

export const portalCompetitionsRoutes = (
  <Route path="competitions">
    <Route index element={<Navigate to="feed" replace />} />
    <Route path="feed" element={<CompetitionsFeed />} />
    <Route path="current">
      <Route index element={<CompetitionsOverview />} />
      <Route path=":id" element={<CompetitionDetails />} />
    </Route>
    <Route path="results">
      <Route index element={<ResultsOverview />} />
      <Route path=":id" element={<ResultDetails />} />
    </Route>
  </Route>
);
